import { render, staticRenderFns } from "./TrainData.vue?vue&type=template&id=ae665b06&scoped=true"
import script from "./TrainData.vue?vue&type=script&lang=js"
export * from "./TrainData.vue?vue&type=script&lang=js"
import style0 from "./TrainData.vue?vue&type=style&index=0&id=ae665b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae665b06",
  null
  
)

export default component.exports